export default __webpack_public_path__ + "static/BG4-0ac86f3ee994dd766d00f9311f8b8e73.jpg";